import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
    success: 'Success',
    info: 'Info',
    error: 'Error',
    warning: 'Warning',
});

// antd mặc định dùng icon Filled (nền tô đặc màu, icon trắng ở giữa) cho notification.
// Đổi sang icon Outlined (nền trắng, chỉ viền + icon tô màu) theo đúng màu status của antd.
const icons = {
    success: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    error: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
    warning: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    info: <InfoCircleOutlined style={{ color: '#1677ff' }} />,
};

export default function useNotification({ placement = 'topRight', duration = 2 } = {}) {
    const intl = useIntl();

    return ({ type = 'success', message, title, onClose }) => {
        notification[type]({
            message: title || intl.formatMessage(messages[type]),
            description: message,
            placement,
            duration,
            onClose,
            icon: icons[type],
        });
    };
}
